"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolver = void 0;
// eslint-disable-next-line
/// <reference path="index.d.ts"/>
var eth_ens_namehash_1 = require("eth-ens-namehash");
var crypto_addr_codec_1 = require("crypto-addr-codec");
var address_encoder_1 = require("@ensdomains/address-encoder");
var rpc_1 = require("./rpc");
var errors = __importStar(require("./errors"));
var contracts_1 = require("./contracts");
var constants_1 = require("./constants");
var Resolver = /** @class */ (function () {
    function Resolver(config) {
        var _a;
        var ethCall = rpc_1.ethCallFactory((_a = config.fetch) !== null && _a !== void 0 ? _a : fetch, config.rpcUrl);
        this.registry = new contracts_1.RegistryContract(config.registryAddress, ethCall);
        this.addrResolverContractFactory = function (address) { return new contracts_1.AddrResolverContract(address, ethCall); };
        this.coinAddrResolverContractFactory = function (address) { return new contracts_1.CoinAddrResolverContract(address, ethCall); };
        this.defaultCoinType = config.defaultCoinType;
        this.addrEncoder = config.addrEncoder;
    }
    Resolver.prototype._addr = function (resolverAddress, node) {
        return __awaiter(this, void 0, void 0, function () {
            var addrResolverContract, supportsAddr, addr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addrResolverContract = this.addrResolverContractFactory(resolverAddress);
                        return [4 /*yield*/, addrResolverContract.supportsAddrInterface(resolverAddress)];
                    case 1:
                        supportsAddr = _a.sent();
                        if (!supportsAddr)
                            throw new Error(errors.ERROR_NOT_ADDR);
                        return [4 /*yield*/, addrResolverContract.getAddr(resolverAddress, node)];
                    case 2:
                        addr = _a.sent();
                        if (addr === constants_1.ZERO_ADDRESS)
                            throw new Error(errors.ERROR_NO_ADDR_SET);
                        return [2 /*return*/, this.addrEncoder(Buffer.from(addr.slice(2), 'hex'))];
                }
            });
        });
    };
    Resolver.prototype._coinAddr = function (resolverAddress, node, coinType) {
        return __awaiter(this, void 0, void 0, function () {
            var coinAddrResolverContract, supportsCoinAddr, addr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        coinAddrResolverContract = this.coinAddrResolverContractFactory(resolverAddress);
                        return [4 /*yield*/, coinAddrResolverContract.supportsCoinAddrInterface(resolverAddress)];
                    case 1:
                        supportsCoinAddr = _a.sent();
                        if (!supportsCoinAddr)
                            throw new Error(errors.ERROR_NOT_COIN_ADDR);
                        return [4 /*yield*/, coinAddrResolverContract.getCoinAddr(resolverAddress, node, coinType)];
                    case 2:
                        addr = _a.sent();
                        if (addr === constants_1.ZERO_BYTES)
                            throw new Error(errors.ERROR_NO_COIN_ADDR_SET);
                        return [2 /*return*/, address_encoder_1.formatsByCoinType[coinType].encoder(Buffer.from(addr, 'hex'))];
                }
            });
        });
    };
    Resolver.prototype.addr = function (domain, coinType) {
        return __awaiter(this, void 0, void 0, function () {
            var node, resolverAddress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        node = eth_ens_namehash_1.hash(domain);
                        return [4 /*yield*/, this.registry.getResolver(node)];
                    case 1:
                        resolverAddress = _a.sent();
                        if (resolverAddress === constants_1.ZERO_ADDRESS)
                            throw new Error(errors.ERROR_NO_RESOLVER);
                        if (!(!coinType && coinType !== 0 || coinType === this.defaultCoinType)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._addr(resolverAddress, node)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [4 /*yield*/, this._coinAddr(resolverAddress, node, coinType)];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Resolver.forRskMainnet = function (config) { return new Resolver(__assign({ registryAddress: '0xcb868aeabd31e2b66f74e9a55cf064abb31a4ad5', rpcUrl: 'https://public-node.rsk.co', addrEncoder: function (buff) { return crypto_addr_codec_1.toChecksumAddress("0x" + buff.toString('hex'), 30); }, defaultCoinType: 137 }, config)); };
    Resolver.forRskTestnet = function (config) { return new Resolver(__assign({ registryAddress: '0x7d284aaac6e925aad802a53c0c69efe3764597b8', rpcUrl: 'https://public-node.testnet.rsk.co', addrEncoder: function (buff) { return crypto_addr_codec_1.toChecksumAddress("0x" + buff.toString('hex'), 31); }, defaultCoinType: 137 }, config)); };
    return Resolver;
}());
exports.Resolver = Resolver;
//# sourceMappingURL=resolver.js.map